// const BASE_URL = "https://vclive.prod-rasiinfotech.in";
// const BASE_URL = "https://ragadiamondslmb1.zinger.co.in";
const BASE_URL = "https://billing.sibirajanagaimaligai.com";

// const BASE_URL = "https://zinger.prod-rasiinfotech.in";

const WEB_URL  = "https://sibirajanagaimaligai.com";

// const BASE_URL = "https://froads.trysumangaleejewellers.in";


export { BASE_URL , WEB_URL};